const textCasos ={
    "contexto":{
        "es":"Contexto",
        "en":"Project overview"
    },
    "investigacion":{
        "es":"Investigación",
        "en":"Research"
    },
    "solucion":{
        "es":"Solución",
        "en":"Solution"
    },
    "aprendizajes":{
        "es":"Aprendizajes",
        "en":"Lessons learned"
    }
}

export default textCasos;